
        document.addEventListener('DOMContentLoaded', () => {
            const NavMenuMobile = document.querySelector(".box-menu-moible");
            const NavButtonMobile = document.querySelector('.mobile-navigation');
            const closeBtn = document.querySelector('.js-close-sidebar');

            console.log(NavMenuMobile);  // Note: Corrected variable name
            console.log('Element loaded');

            NavButtonMobile.addEventListener("click", () => {
                console.log('click');
                 NavMenuMobile.classList.toggle('js-menu');
                 
            });
 closeBtn.addEventListener("click", () => {
                console.log('click');
                 NavMenuMobile.classList.remove('js-menu');
                 
            });
           
        });
